/** Tras login: abrir detalle de producto (link WhatsApp #/p/...) */
export const SS_PENDING_PRODUCT_OPEN = 'mlv_pending_product_open';

/** Invitado / cold start: abrir publicaciones por UID (#/perfil-vendedor/{uid}) */
export const SS_PENDING_PERFIL_VENDEDOR_UID = 'mlv_pending_perfil_vendedor_uid';

/** Explorar catálogo desde login sin sesión: fuerza UI de invitado aunque exista persistencia rara. */
export const SS_GUEST_EXPLORE = 'mlv_guest_explore';
